package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.BoxSizing.BORDER_BOX
import com.downdogapp.Color.Companion.BLACK
import com.downdogapp.Color.Companion.WHITE
import com.downdogapp.FlexWrap.NOWRAP
import com.downdogapp.FontWeight.LIGHT
import com.downdogapp.FontWeight.MEDIUM
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Overflow.AUTO
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.MixViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.views.start.StartView
import com.downdogapp.client.widget.*
import kotlinx.dom.clear
import org.w3c.dom.HTMLDivElement

actual class MixView actual constructor(private val controller: MixViewController)
  : TopLevelView(), View {

  private var mixRows: List<MixViewRow>
  private var mixRowsDiv: HTMLDivElement
  private var mixPresetsContainer: HTMLDivElement
  private var selectedPreset: HTMLDivElement? = null

  override val root =
    controllerView {
      background(true)

      fg = foreground(!controller.isOnboarding) {
        horizontalFlexBox(horizontalJustify = JustifyContent.CENTER) {
          height = Size.vh(100)
          width = percent(100)

          verticalFlexBox {
            height = Size.vh(100)
            width = MIX_VIEW_WIDTH
            paddingBottom = percent(2)
            boxSizing = BORDER_BOX

            if (controller.isOnboarding) {
              horizontalFlexBox(horizontalJustify = SPACE_BETWEEN) {
                marginTop = px(15)
                width = percent(100)

                imageButton(
                  image = Images.SETTINGS_LEFT_ARROW,
                  clickFn = controller::onBackClicked
                ) {
                  marginTop = px(5)
                }

                if (controller.isOnboarding) {
                  horizontalFlexBox {
                    marginTop = px(20)
                    for (i in 0..<controller.numOnboardingScreens!!) {
                      val image = if (i == controller.onboardingScreenIndex!!)
                        Images.ONBOARDING_PROGRESS_ACTIVE
                      else
                        Images.ONBOARDING_PROGRESS_INACTIVE

                      imageView(image) {
                        marginHorizontal = px(3)
                      }
                    }
                  }

                  textButton(
                    text = Strings.SKIP,
                    fontSize = 20,
                    fontWeight = MEDIUM,
                    clickFn = controller::onFinish
                  )
                }
              }
            }

            verticalFlexBox {
              marginTop = StartView.TITLE_TOP_MARGIN_PX - if (controller.isOnboarding) px(40) else px(0)

              label(
                text = controller.selectorItem.selectorTitle,
                fontSize = 28,
                fontWeight = MEDIUM,
                textAlign = CENTER
              ) {
                marginBottom = px(30)
              }

              horizontalFlexBox(flexWrap = NOWRAP) {
                marginBottom = px(20)
                paddingBottom = px(5)
                overflowX = AUTO

                if (controller.mixPresets.size > 4) {
                  mask = CSSImage.linearGradient(
                    listOf(
                      CSSImage.Gradient.linearColorStop(BLACK, percent(85)),
                      CSSImage.Gradient.linearColorStop(Color.TRANSPARENT)
                    ),
                    direction = Direction.RIGHT
                  )
                }

                mixPresetsContainer = horizontalFlexBox {
                  if (controller.mixPresets.size > 4) {
                    paddingRight = px(40)
                  }
                }
              }

              verticalFlexBox {
                width = MIX_VIEW_WIDTH
                height = percent(80)
                borderRadius = px(25)
                bgColor = BLACK

                div {
                  overflowY = AUTO
                  marginTop = px(25)
                  flexGrow = 1.0
                  mixRowsDiv = div {
                    overflowY = AUTO
                    marginTop = px(-10)

                    mixRows = controller.mixGroups.map {
                      mixViewRow(it, controller)
                    }
                  }
                }

                roundedTextButton(
                  text = Strings.SELECT,
                  marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
                  clickFn = controller::onFinish
                ) {
                  marginTop = px(10)
                  marginBottom = px(25)
                }
              }
            }
          }
        }
      }
    }

  actual override fun refreshView() {
    super.refreshView()
    populatePresetList()
    mixRows.forEach {
      it.refreshView()
    }
  }

  override fun onBecameVisible() {
    selectedPreset?.scrollToCenter()
  }

  private fun populatePresetList() {
    mixPresetsContainer.clear()
    controller.mixPresets
      .map { preset ->
        val isSelected = controller.isSelected(preset)
        mixPresetsContainer.horizontalFlexBox(
          horizontalJustify = JustifyContent.CENTER,
          verticalAlign = AlignItems.CENTER
        ) {
          padding = px(15)
          borderRadius = px(8)
          marginRight = px(7)
          bgColor = if (isSelected) Color.white(0.9) else Color.grey(0.15)

          if (controller.isSelected(preset)) {
            selectedPreset = this
          } else {
            onClick {
              controller.setSelectedPreset(preset)
            }
          }

          div {
            width = px(90)
            textAlign = CENTER

            label(text = preset.label, fontSize = 16, fontWeight = LIGHT, color = if (isSelected) BLACK else WHITE)
          }
        }
      }
  }

  companion object {

    val MIX_VIEW_WIDTH = px(560)
  }
}
